import React from 'react';
import { isMobileFilter } from 'swag-client-common/utils/ui.utils';
import placeholder from 'assets/img/image-placeholder.png';
import classes from './brands.scss';
export const Brands = ({
  headingText,
  logos
}) => {
  var _logos;
  const isInIFrame = window.self !== window.top;
  if ((!logos || ((_logos = logos) === null || _logos === void 0 ? void 0 : _logos.length) === 0) && !isInIFrame) {
    return null;
  }
  const getContent = () => {
    var _logos2;
    if (isInIFrame && (!logos || ((_logos2 = logos) === null || _logos2 === void 0 ? void 0 : _logos2.length) === 0)) {
      logos = new Array(8).fill(placeholder);
    }
    if (isMobileFilter() && logos.length > 4) {
      const half = Math.round(logos.length / 2);
      return /*#__PURE__*/React.createElement("div", {
        className: classes.animWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.contentPart0
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.brandsList
      }, logos.slice(0, half).map(imgSrc => /*#__PURE__*/React.createElement("img", {
        src: imgSrc
      })))), /*#__PURE__*/React.createElement("div", {
        className: classes.contentPart1
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.brandsList
      }, logos.slice(half).map(imgSrc => /*#__PURE__*/React.createElement("img", {
        src: imgSrc
      })))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.brandsList
    }, logos.map(imgSrc => /*#__PURE__*/React.createElement("img", {
      src: imgSrc
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, headingText || 'Some of our favorite customers'), getContent());
};